import { Component, Input, OnInit } from '@angular/core';
import { Document } from '../../../models/document';
import { PrinterService } from '../services/printer.service';
import { DocumentModalComponent } from '../document-modal/document-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { DocumentTypeEnum } from '../../../enum/document-type.enum';

import { MatButton, MatIconButton } from '@angular/material/button';
import { IconComponent } from '../icon/icon.component';
import { IconEnum } from '../../../enum/icon.enum';

@Component({
    selector: 'app-document-link',
    templateUrl: './document-link.component.html',
    styleUrls: ['./document-link.component.scss'],
    imports: [
    MatIconButton,
    IconComponent,
    MatButton
]
})
export class DocumentLinkComponent implements OnInit {

    @Input()
    document: Document;

    @Input()
    format: string;

    constructor(private printer: PrinterService, private dialog: MatDialog) {
    }

    ngOnInit(): void {
    }

    displayName(): string {
        switch (this.document.type) {
            case DocumentTypeEnum.WAYBILL:
                return $localize`Waybill`;
            case DocumentTypeEnum.INVOICE:
                return $localize`Invoice`;
            case DocumentTypeEnum.SHIPMENT_SUMMARY:
                return $localize`Shipment Summary`;
            case DocumentTypeEnum.PROOF_OF_DELIVERY:
                return $localize`Proof of Delivery`;
            case DocumentTypeEnum.COMMERCIAL_INVOICE:
                return $localize`Commercial Invoice`;
            default:
                return this.document.filename;
        }
    }

    showIcon(): boolean {
        if (!this.format) {
            switch (this.document.type) {
                case DocumentTypeEnum.WAYBILL:
                case DocumentTypeEnum.INVOICE:
                case DocumentTypeEnum.PROOF_OF_DELIVERY:
                case DocumentTypeEnum.SHIPMENT_SUMMARY:
                case DocumentTypeEnum.COMMERCIAL_INVOICE:
                    return true;
                default:
                    return false;
            }
        }
        return this.format === 'icon';
    }

    icon(): IconEnum {
        switch (this.document.type) {
            case DocumentTypeEnum.PROOF_OF_DELIVERY:
                return 'proof-of-delivery';
            case DocumentTypeEnum.WAYBILL:
                return 'waybill';
            case DocumentTypeEnum.SHIPMENT_SUMMARY:
                return 'quote-summary';
            case DocumentTypeEnum.COMMERCIAL_INVOICE:
                return 'commercial-invoice';
            default:
                return 'file';
        }
    }

    open(): void {
        switch (this.document.mimeType) {
            case 'application/zpl':
                this.printer.printZpl(this.document.url);
                break;
            case 'image/png':
            case 'image/gif':
                this.printer.printImage(this.document.url);
                break;
            default:
                this.printer.printPdf(this.document.url);
                break;
        }
        return;
        this.dialog.open(DocumentModalComponent, {
            data: this.document,
            width: '100vw',
            height: '100vh'
        });
    }
}
